import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  GET_PROVIDER_NPI_REQUEST: '',
  GET_PROVIDER_NPI_SUCCESS: '',
  GET_PROVIDER_NPI_FAILURE: '',

  GET_OTHER_PROVIDER_NPI_REQUEST: '',
  GET_OTHER_PROVIDER_NPI_SUCCESS: '',
  GET_OTHER_PROVIDER_NPI_FAILURE: '',

  CHECK_IS_DME_REQUEST: '',
  CHECK_IS_DME_SUCCESS: '',
  CHECK_IS_DME_FAILURE: '',

  VALIDATE_RENDERING_NPI_REQUEST: '',
  VALIDATE_RENDERING_NPI_SUCCESS: '',
  VALIDATE_RENDERING_NPI_FAILURE: '',

  VERIFY_NPI_REQUEST: '',
  VERIFY_NPI_SUCCESS: '',
  VERIFY_NPI_FAILURE: '',

  GET_NAME_FROM_NPI_REQUEST: '',
  GET_NAME_FROM_NPI_SUCCESS: '',
  GET_NAME_FROM_NPI_FAILURE: '',

  GET_RMIPROVKEYID_FROM_NPI_REQUEST: '',
  GET_RMIPROVKEYID_FROM_NPI_SUCCESS: '',
  GET_RMIPROVKEYID_FROM_NPI_FAILURE: '',

  GET_NAME_AND_ID_FROM_RMIPROVKEYID_REQUEST: '',
  GET_NAME_AND_ID_FROM_RMIPROVKEYID_SUCCESS: '',
  GET_NAME_AND_ID_FROM_RMIPROVKEYID_FAILURE: '',

};

types = setStoreTypeValues(types, 'claimNPI');

export default types;
